import React, { useEffect, useState } from 'react';
import { getListChallengeByBounty, createChallenge, updateChallenge, deleteChallenge } from 'redux/actions/daoUI/challenges.action';
import ChallengeDetailModal from './ChallengeDetailModal';
import ChallengeFullDetailModal from './ChallengeFullDetailModal';

const ChallengesTab = ({ bountyId, activeTab }) => {
  const [challenges, setChallenges] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [total, setTotal] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState('create'); // 'create' | 'detail' | 'update'
  const [selectedChallenge, setSelectedChallenge] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [challengeToDelete, setChallengeToDelete] = useState(null);
  const [fullDetailModalOpen, setFullDetailModalOpen] = useState(false);

  useEffect(() => {
    if (activeTab === 'CHALLENGES') {
      const fetchChallenges = async () => {
        setLoading(true);
        setError(null);
        try {
          const params = { bountyId, page, limit };
          const data = await getListChallengeByBounty(params)();
          setChallenges(data?.data || []);
          setTotal(data?.pagination?.total || 0);
        } catch (err) {
          setError('Lỗi khi tải danh sách challenge');
        } finally {
          setLoading(false);
        }
      };
      if (bountyId) fetchChallenges();
    }
  }, [activeTab, bountyId, page, limit]);

  const openCreateModal = () => {
    setModalMode('create');
    setSelectedChallenge(null);
    setModalOpen(true);
  };

  const openDetailModal = (challenge) => {
    setModalMode('detail');
    setSelectedChallenge(challenge);
    setModalOpen(true);
  };

  const openUpdateModal = (challenge, e) => {
    if (e) e.stopPropagation();
    setModalMode('update');
    setSelectedChallenge(challenge);
    setModalOpen(true);
  };

  const handleDelete = async (challenge, e) => {
    if (e) e.stopPropagation();
    setChallengeToDelete(challenge);
    setConfirmDelete(true);
  };

  const confirmDeleteChallenge = async () => {
    if (!challengeToDelete) return;
    
    try {
      await deleteChallenge(challengeToDelete._id)();
      // Refresh danh sách challenges
      const params = { bountyId, page, limit };
      const response = await getListChallengeByBounty(params)();
      setChallenges(response?.data || []);
      setTotal(response?.pagination?.total || 0);
    } catch (error) {
      console.error('Error deleting challenge:', error);
    } finally {
      setConfirmDelete(false);
      setChallengeToDelete(null);
    }
  };

  const cancelDelete = () => {
    setConfirmDelete(false);
    setChallengeToDelete(null);
  };

  const handleSubmit = async (data) => {
    try {
      if (modalMode === 'create') {
        await createChallenge({ ...data, bounty_id: bountyId })();
      } else if (modalMode === 'update' && selectedChallenge?._id) {
        await updateChallenge(selectedChallenge._id, data)();
      }
      setModalOpen(false);
      // Refresh danh sách challenges
      const params = { bountyId, page, limit };
      const response = await getListChallengeByBounty(params)();
      setChallenges(response?.data || []);
      setTotal(response?.pagination?.total || 0);
    } catch (error) {
      console.error('Error submitting challenge:', error);
    }
  };

  // Phương thức để mở modal chi tiết đầy đủ
  const openFullDetailModal = (challenge, e) => {
    if (e) e.stopPropagation();
    setSelectedChallenge(challenge);
    setFullDetailModalOpen(true);
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
        <h3 style={{ color: '#03edc3' }}>Challenges</h3>
        <button
          style={{
            background: '#232b5b',
            color: '#fff',
            border: 'none',
            borderRadius: '50%',
            width: 24,
            height: 24,
            fontSize: 18,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: '10px',
            marginBottom: '10px'
          }}
          onClick={openCreateModal}
        >+</button>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, background: '#fff', color: '#181c22', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 8px #0006' }}>
          <thead>
            <tr style={{ backgroundColor: '#f5f5f5' }}>
              <th style={{ padding: '14px', textAlign: 'left' }}>Name</th>
              <th style={{ padding: '14px', textAlign: 'left' }}>Type</th>
              <th style={{ padding: '14px', textAlign: 'left' }}>Created Time</th>
              <th style={{ padding: '14px', textAlign: 'left' }}>Updated Time</th>
              <th style={{ padding: '14px', textAlign: 'center' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {challenges.map((challenge, idx) => (
              <tr key={challenge._id} onClick={() => openDetailModal(challenge)} style={{ cursor: 'pointer' }}>
                <td style={{ padding: '12px' }}>{challenge.name}</td>
                <td style={{ padding: '12px' }}>{challenge.type}</td>
                <td style={{ padding: '12px' }}>{challenge.createdAt ? new Date(challenge.createdAt).toLocaleString() : ''}</td>
                <td style={{ padding: '12px' }}>{challenge.updatedAt ? new Date(challenge.updatedAt).toLocaleString() : ''}</td>
                <td style={{ padding: '12px', textAlign: 'center' }}>
                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      openFullDetailModal(challenge, e);
                    }}
                    style={{
                      padding: '4px 8px',
                      margin: '0 4px',
                      background: '#e0f7fa',
                      color: '#006064',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    👁️
                  </button>
                  <button 
                    onClick={(e) => openUpdateModal(challenge, e)}
                    style={{
                      padding: '4px 8px',
                      margin: '0 4px',
                      background: '#e8f5e9',
                      color: '#2e7d32',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    ✏️
                  </button>
                  <button 
                    onClick={(e) => handleDelete(challenge, e)}
                    style={{
                      padding: '4px 8px',
                      margin: '0 4px',
                      background: '#ffebee',
                      color: '#c62828',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    🗑️
                  </button>
                </td>
              </tr>
            ))}
            {challenges.length === 0 && !loading && (
              <tr>
                <td colSpan={5} style={{ textAlign: 'center', color: '#888', padding: 24 }}>No data</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div style={{ marginTop: '20px' }}>
        <button
          onClick={() => setPage(p => Math.max(1, p - 1))}
          disabled={page === 1}
          style={{
            padding: '8px 16px',
            backgroundColor: '#00ffe0',
            color: '#181c22',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: 'bold',
            marginRight: '10px',
            opacity: page === 1 ? 0.5 : 1
          }}
        >
          Previous Page
        </button>
        <span style={{ margin: '0 10px', color: '#181c22' }}>Page {page}</span>
        <button
          onClick={() => setPage(p => p + 1)}
          disabled={page >= Math.ceil(total / limit)}
          style={{
            padding: '8px 16px',
            backgroundColor: '#00ffe0',
            color: '#181c22',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: 'bold',
            opacity: page >= Math.ceil(total / limit) ? 0.5 : 1
          }}
        >
          Next Page
        </button>
      </div>
      <ChallengeDetailModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        challenge={selectedChallenge}
        mode={modalMode}
        bountyId={bountyId}
        onSubmit={handleSubmit}
      />
      
      {confirmDelete && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: '#fff',
            padding: '20px',
            borderRadius: '8px',
            maxWidth: '400px',
            width: '100%'
          }}>
            <h3 style={{ marginTop: 0 }}>Xác nhận xóa</h3>
            <p>Bạn có chắc chắn muốn xóa challenge "{challengeToDelete?.name}"?</p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
              <button
                onClick={cancelDelete}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#e0e0e0',
                  color: '#333',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                Hủy
              </button>
              <button
                onClick={confirmDeleteChallenge}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#f44336',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                Xóa
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal chi tiết đầy đủ */}
      {fullDetailModalOpen && (
        <ChallengeFullDetailModal 
          challenge={selectedChallenge}
          bountyId={bountyId}
          onClose={() => setFullDetailModalOpen(false)}
        />
      )}
    </div>
  );
};

export default ChallengesTab; 